import { render, staticRenderFns } from "./MMP_DisplayClickCoords.vue?vue&type=template&id=230d5ee6&scoped=true&"
import script from "./MMP_DisplayClickCoords.vue?vue&type=script&lang=js&"
export * from "./MMP_DisplayClickCoords.vue?vue&type=script&lang=js&"
import style0 from "./MMP_DisplayClickCoords.vue?vue&type=style&index=0&id=230d5ee6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230d5ee6",
  null
  
)

export default component.exports